export const COMPANY_NAME = "星光传媒";

export const COMPANY_TAGLINE = "把好故事，送到每一个还愿意抬头的人手里";

export const COMPANY_INTRO =
  "星光传媒是一家专注于影视内容制作与推荐的内容机构，旗下覆盖电影、剧集与影视资讯三条内容线。我们与创作者一起打磨作品，也替观众把散落在世界各地的好故事收集起来。";

export interface Milestone {
  year: string;
  title: string;
  description: string;
}

export const milestones: Milestone[] = [
  {
    year: "2014",
    title: "从一间放映室开始",
    description: "三位影迷在一间只有 28 个座位的放映室里办了第一场主题影展，那一晚来了 41 个人，多出来的 13 个人坐在了台阶上。",
  },
  {
    year: "2017",
    title: "成立内容编辑部",
    description: "组建第一支影视资讯编辑团队，开始系统整理华语与海外作品的幕后资料，建立自有资料库。",
  },
  {
    year: "2020",
    title: "参与首部联合出品",
    description: "以联合出品方身份参与《潮汐之上》早期开发，第一次从观众席位走到创作现场。",
  },
  {
    year: "2022",
    title: "推出剧集推荐体系",
    description: "上线“星光片单”，由编辑与观众共同评分，形成一套以“值得看完”为标准的推荐机制。",
  },
  {
    year: "2024",
    title: "建立线下放映网络",
    description: "在六个城市建立合作放映空间，累计举办 260 余场主题放映与主创交流活动。",
  },
  {
    year: "2026",
    title: "走向内容制作上游",
    description: "发布年度片单与“新光计划”，支持青年导演首部长片，同时推进自有剧集与纪录内容。",
  },
];

export interface ContentScope {
  icon: string;
  title: string;
  description: string;
}

export const contentScopes: ContentScope[] = [
  {
    icon: "ri-film-line",
    title: "电影推荐与解读",
    description: "覆盖院线与影展作品，从剧情、表演到视听语言提供多维度解读，帮助观众在开映前就找到适合自己的那一部。",
  },
  {
    icon: "ri-tv-2-line",
    title: "剧集追踪与热播榜单",
    description: "按题材、地区与口碑整理剧集信息，持续跟进播出节奏，避免错过任何一次更新的关键转折。",
  },
  {
    icon: "ri-newspaper-line",
    title: "影视资讯与独家采访",
    description: "每日更新行业动态、幕后花絮与主创独家采访，把银幕之外的故事也讲完整。",
  },
  {
    icon: "ri-calendar-check-line",
    title: "线下放映与主创交流",
    description: "在多个城市合作放映空间举办主题影展，映后邀请主创到场，把观看变成一次面对面的交流。",
  },
];

export interface CompanyStat {
  value: string;
  label: string;
  description: string;
}

export const companyStats: CompanyStat[] = [
  { value: "12", label: "年深耕影视内容", description: "从放映室到制作现场" },
  { value: "860+", label: "部作品深度解读", description: "编辑团队长期积累" },
  { value: "260+", label: "场主题放映", description: "覆盖六个城市" },
  { value: "94%", label: "观众推荐度", description: "来自星光片单用户" },
];